import { DirectionsRequestOptions, DirectionsResponse, requestDirections } from './directions'
import { DistanceMatrixRequestOptions, DistanceMatrixResponse, requestDistanceMatrix } from './distance-matrix'
import { requestSnapToRoads, SnapToRoadsRequestOptions, SnapToRoadsResponse } from './snap-to-roads'
import { requestGetNearby, GetNearbyRequestOptions, GetNearbyResponse } from './get-nearby'
import { requestPostTripRoute, PostTripRouteRequestOptions, PostTripRouteResponse } from './post-trip-route'

export default {
  Directions: async (opt: DirectionsRequestOptions): Promise<DirectionsResponse | null> => {
    return requestDirections(opt)
  },
  DistanceMatrix: async (opt: DistanceMatrixRequestOptions): Promise<DistanceMatrixResponse | null> => {
    return requestDistanceMatrix(opt)
  },
  SnapToRoads: async (opt: SnapToRoadsRequestOptions): Promise<SnapToRoadsResponse | null> => {
    return requestSnapToRoads(opt)
  },
  GetNearby: async (opt: GetNearbyRequestOptions): Promise<GetNearbyResponse | null> => {
    return requestGetNearby(opt)
  },
  PostTripRoute: async (opt: PostTripRouteRequestOptions): Promise<PostTripRouteResponse | null> => {
    return requestPostTripRoute(opt)
  },
}
